// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/shared/loyalty_membership.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/booking/shared/loyalty_membership.proto.
 */
export const file_proto_model_booking_shared_loyalty_membership = /*@__PURE__*/
  fileDesc("CjNwcm90by9tb2RlbC9ib29raW5nL3NoYXJlZC9sb3lhbHR5X21lbWJlcnNoaXAucHJvdG8SBmNhcm1lbiLnBgoRTG95YWx0eU1lbWJlcnNoaXASQgoMcHJvZ3JhbV90eXBlGAEgASgOMiwuY2FybWVuLkxveWFsdHlNZW1iZXJzaGlwLkxveWFsdHlQcm9ncmFtVHlwZRIUCgxwcm9ncmFtX25hbWUYAiABKAkSGwoTcHJvdmlkZXJfaWRlbnRpZmllchgDIAEoCRIVCg1tZW1iZXJfbnVtYmVyGAQgASgJEhEKCXRpZXJfbmFtZRgFIAEoCRIPCgdiYWxhbmNlGAYgASgFEkwKEXVzYWdlX3ByZWZlcmVuY2VzGAcgASgLMjEuY2FybWVuLkxveWFsdHlNZW1iZXJzaGlwLkxveWFsdHlVc2FnZVByZWZlcmVuY2VzEkYKD2FkZGl0aW9uYWxfZGF0YRgIIAMoCzItLmNhcm1lbi5Mb3lhbHR5TWVtYmVyc2hpcC5BZGRpdGlvbmFsRGF0YUVudHJ5Gn8KF0xveWFsdHlVc2FnZVByZWZlcmVuY2VzEhgKEHVzZV9mb3JfYmVuZWZpdHMYASABKAgSFwoPdXNlX2Zvcl9wYXltZW50GAIgASgIEhgKEHVzZV9mb3JfdXBncmFkZXMYAyABKAgSFwoPdXNlX2Zvcl9lYXJuaW5nGAQgASgIGjUKE0FkZGl0aW9uYWxEYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASLRAgoSTG95YWx0eVByb2dyYW1UeXBlEiQKIExPWUFMVFlfUFJPR1JBTV9UWVBFX1VOU1BFQ0lGSUVEEAASIAocTE9ZQUxUWV9QUk9HUkFNX1RZUEVfQUlSTElORRABEh4KGkxPWUFMVFlfUFJPR1JBTV9UWVBFX0hPVEVMEAISIwofTE9ZQUxUWV9QUk9HUkFNX1RZUEVfQ0FSX1JFTlRBTBADEiMKH0xPWUFMVFlfUFJPR1JBTV9UWVBFX1JFU1RBVVJBTlQQBBIhCh1MT1lBTFRZX1BST0dSQU1fVFlQRV9BQ1RJVklUWRAFEh8KG0xPWUFMVFlfUFJPR1JBTV9UWVBFX0NSVUlTRRAGEh4KGkxPWUFMVFlfUFJPR1JBTV9UWVBFX1RSQUlOEAcSJQohTE9ZQUxUWV9QUk9HUkFNX1RZUEVfVFJBVkVMX0FHRU5UEAhCMFouZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWwvYm9va2luZ2IGcHJvdG8z");

/**
 * Describes the message carmen.LoyaltyMembership.
 * Use `create(LoyaltyMembershipSchema)` to create a new message.
 */
export const LoyaltyMembershipSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_shared_loyalty_membership, 0);

/**
 * Describes the message carmen.LoyaltyMembership.LoyaltyUsagePreferences.
 * Use `create(LoyaltyMembership_LoyaltyUsagePreferencesSchema)` to create a new message.
 */
export const LoyaltyMembership_LoyaltyUsagePreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_shared_loyalty_membership, 0, 0);

/**
 * Describes the enum carmen.LoyaltyMembership.LoyaltyProgramType.
 */
export const LoyaltyMembership_LoyaltyProgramTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_shared_loyalty_membership, 0, 0);

/**
 * @generated from enum carmen.LoyaltyMembership.LoyaltyProgramType
 */
export const LoyaltyMembership_LoyaltyProgramType = /*@__PURE__*/
  tsEnum(LoyaltyMembership_LoyaltyProgramTypeSchema);

